import { AdminRO } from '@routellers/types/dist/admin/admin.ro';
import { CreateAdminDto } from '@routellers/types/dist/admin/create-admin.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    data: CreateAdminDto;
};

type ResponseData = AdminRO;

export const create: ApiMethodDeclaration<ParamsData, ResponseData> = ({ data }) => ({
    url: '/admins',
    method: 'POST',
    data,
});
